import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import styles from '../styles/components/_PageTransition.module.scss';
import { useCustomNavigation } from './NavigationContext';

gsap.registerPlugin(ScrollToPlugin);

const PageTransition = ({ children, videoHeaderRef }) => {
  const { isTransitioning, finishNavigation } = useCustomNavigation();
  const transitionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isTransitioning) {
      performTransition();
    }
  }, [isTransitioning]);

  const performTransition = async () => {
    await animateOutro();
    window.scrollTo(0, 1);
    finishNavigation();
    await animateIntro();
  };

  const animateOutro = () => {
    return new Promise((resolve) => {
      const tl = gsap.timeline({ onComplete: resolve });
      
      tl.to(contentRef.current, {
        opacity: 0,
        y: -30,
        duration: 0.3,
        ease: "power2.inOut"
      });

      if (videoHeaderRef && videoHeaderRef.current) {
        tl.to(videoHeaderRef.current, {
          opacity: 0,
          duration: 0.4,
          ease: "power2.inOut"
        }, "-=0.3");
      }
    });
  };

  const animateIntro = () => {
    return new Promise((resolve) => {
      const tl = gsap.timeline({ onComplete: resolve });

      tl.fromTo([contentRef.current, videoHeaderRef?.current].filter(Boolean),
        {
          opacity: 0,
          y: 0
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power3.out",
          stagger: 0.1
        }
      );
    });
  };

  return (
    <div ref={transitionRef} className={styles.pageTransition}>
      <div ref={contentRef} className={styles.pageContent}>
        {children}
      </div>
    </div>
  );
};

export default PageTransition;
